import React from "react"
import { css } from "emotion"
import Toast from "./Toast"
import type { Notification } from "../types"

export interface ToastContainerProps {
	notifications: Notification[]
	updateWhichThreadIsOpen: (threadIndex: number) => void
}

export default function ToastContainer(props: ToastContainerProps) {
	return (
		<div
			className={css`
				position: fixed;
				overflow-y: hidden;
				height: 600px;
				right: 0.5em;
				top: 0.5em;
				z-index: 1000004;

				@media only screen and (max-width: 400px) {
					display: none;
					visibility: hidden;
				}
			`}
		>
			{props.notifications.map((notification, index) => (
				<Toast
					key={index}
					notification={notification}
					onGoToThread={props.updateWhichThreadIsOpen}
				/>
			))}
		</div>
	)
}
